import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import styles from './ContactUs.module.scss';
import { thinkingFace } from '@/assets/images/emojis';
import { useFreshchat } from '../../hooks/useFreshchat';

export const ContactUs = ({
  buttonVariant = 'filled',
}: {
  buttonVariant?: 'filled' | 'outlined';
}) => {
  const { showWidget } = useFreshchat();

  return (
    <div className={styles.root}>
      <div className={styles.contactHeader}>
        <img
          src={thinkingFace}
          alt="Thinking emoji"
          className={styles.thinkingEmoji}
        />
        <h2 className={styles.contactTitle}>Ai nevoie de ajutor?</h2>
      </div>
      <p className={styles.contactDescription}>
        Pentru orice întrebări, suntem disponibili de <br /> Luni până Vineri,
        între orele 09:00 și 17:00
      </p>
      <Button
        trackingId="contact_us"
        variant={buttonVariant}
        leftIcon={<Icon name="chats-text" />}
        onClick={showWidget}
        className={styles.contactButton}
        text="Contactează-ne"
      />
    </div>
  );
};
